<script setup>
import { BAccordion, BAccordionItem } from 'bootstrap-vue-next';
import { computed } from 'vue';

import CurrentContributorSection from './notable-contributors-page/CurrentContributorSection.vue';
import releases from './notable-contributors-page/data';
import HeaderSection from './notable-contributors-page/HeaderSection.vue';
import PastContributorsSection from './notable-contributors-page/PastContributorsSection.vue';

const currentRelease = computed(() => releases[0]);
const pastReleases = computed(() => releases.slice(1));
</script>

<template>
  <div>
    <HeaderSection
      class="mt-3 mb-2"
      :release="currentRelease"
    />

    <CurrentContributorSection :release="currentRelease" />

    <BAccordion class="accordion-table">
      <BAccordionItem
        title="About the Notable Contributor award"
      >
        <div class="p-3">
          <p>
            Every month GitLab recognizes one or more wider community members with the
            <strong>GitLab Notable Contributor</strong> award.
            This was formerly known as GitLab MVP ("Most Valuable Person").
            GitLab Notable Contributors earn:
          </p>
          <ul>
            <li>Featured write-up in the GitLab release post.</li>
            <li>Notable Contributor achievement badge in their user profile.</li>
            <li>GitLab rewards store credits.</li>
          </ul>
          <p>
            Everyone is eligible for consideration and we value both code and non-code
            contributions to GitLab as well as contributors who uphold the
            <a
              href="https://handbook.gitlab.com/handbook/values/"
              target="_blank"
            >GitLab Values</a>
            and support the community.
            Nominate a community contributor by commenting in the
            <a
              href="https://gitlab.com/gitlab-org/developer-relations/contributor-success/team-task/-/issues/?label_name%5B%5D=Notable%20contributor%20nominations"
              target="_blank"
            >current nomination issue</a>.
          </p>
        </div>
      </BAccordionItem>
    </BAccordion>

    <PastContributorsSection :releases="pastReleases" />
  </div>
</template>
